import React from 'react';
import { useUser } from '../contexts/UserContext';
import Home from './Home';
import SignedInUser from './SignedInUser';

const Root: React.FC = () => {
  const { user } = useUser();

  return (
    <>
      <div className="relative flex justify-center screen bg-gradient-to-b from-blue-50 to-white">
        {user ? (
          <SignedInUser user={user} />
        ) : (
          <Home />
        )
        }
      </div>

    </>
  );
};

export default Root;